import React from 'react';
import { StyledBrand, StyledBrandLogo, StyledBrandTitle } from './styledBrand';

export interface IBrandProps {
  title: string;
  logo: string;
  size?: 'md' | 'lg';
  alt?: string;
  otherProps?: Record<string, unknown>;
}

const Brand = ({ title, logo, size, alt, otherProps }: IBrandProps): JSX.Element => (
  <StyledBrand tag="div" {...otherProps}>
    <>
      <StyledBrandLogo src={logo} alt={alt || title} size={size} data-test-id="NavBarBrand-logo" />
      <StyledBrandTitle data-test-id="NavBarBrand-title">{title}</StyledBrandTitle>
    </>
  </StyledBrand>
);

export default Brand;
